import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Centered } from 'atoms/layout/Centered';

import { BackButton } from '../BackButton';
import { CloseButton } from '../CloseButton';

const Container = styled(Centered)`
  padding: var(--double-unit);
  &.withDivider {
    border-bottom: 1px solid var(--c-nd-150);
  }
`;

type Props = {
  onBack?: () => void;
  onClose?: () => void;
  title?: ReactNode;
  transparentButton?: boolean;
  withDivider?: boolean;
};

export const Header = ({
  onBack,
  title,
  onClose,
  transparentButton,
  withDivider,
}: Props) => (
  <Container
    className={classNames({ withDivider })}
    left={!!onBack && <BackButton onBack={onBack} />}
    right={
      !!onClose && (
        <CloseButton onClose={onClose} transparent={transparentButton} />
      )
    }
  >
    {typeof title === 'string' ? <span>{title}</span> : title}
  </Container>
);
